import { CustomRoute } from '@app/components/layout/sidebar/components/route';
import SettingsPage from '@app/pages/settings/settings-page';
import { Route } from 'react-router-dom';
import { GROUP_ROUTES } from './config/pages';
import GroupContextProvider from './group-context';
import GroupLayout from './group-layout';
import GroupCollectionsPage from './pages/group-collections-page';
import GroupCompanyEmissionsPage from './pages/group-company-emissions-page';
import GroupCompanyReportsPage from './pages/group-company-reports-page';
import GroupDashboardPage from './pages/group-dashboard-page';
import GroupFoodAndDrinkPage from './pages/group-food-and-drink-page';
import GroupOrganizationUsersPage from './pages/group-organization-users-page';
import GroupOrganizationsPage from './pages/group-organizations-page';
import GroupPackagingPage from './pages/group-packaging-page';
import GroupProductsPage from './pages/group-products-page';
import GroupPurchasingEmissionsPage from './pages/group-purchasing-emissions-page';

/** Re-export so consumers (HomeRedirect, NavUser etc) continue to work. */
export const groupRoutes = {
  GROUP_DASHBOARD: GROUP_ROUTES.DASHBOARD,
  GROUP_ORGANIZATIONS: GROUP_ROUTES.ORGANIZATIONS,
  GROUP_COMPANY_EMISSIONS: GROUP_ROUTES.COMPANY_EMISSIONS,
  GROUP_COMPANY_REPORTS: GROUP_ROUTES.COMPANY_REPORTS,
  GROUP_PURCHASING_EMISSIONS: GROUP_ROUTES.PURCHASING_EMISSIONS,
  GROUP_PURCHASING_FOOD_AND_DRINK: GROUP_ROUTES.PURCHASING_FOOD_AND_DRINK,
  GROUP_PURCHASING_PACKAGING: GROUP_ROUTES.PURCHASING_PACKAGING,
  GROUP_PRODUCTS: GROUP_ROUTES.PRODUCTS,
  GROUP_PRODUCTS_COLLECTIONS: GROUP_ROUTES.PRODUCTS_COLLECTIONS,
  GROUP_SETTINGS: GROUP_ROUTES.SETTINGS,
};

export function GroupRoutes() {
  return (
    <Route element={<CustomRoute element={<GroupContextProvider />} />}>
      <Route element={<GroupLayout />}>
        <Route path={GROUP_ROUTES.DASHBOARD} element={<GroupDashboardPage />} />
        <Route
          path={GROUP_ROUTES.ORGANIZATIONS}
          element={<GroupOrganizationsPage />}
        />
        <Route
          path={GROUP_ROUTES.ORGANIZATION_USERS}
          element={<GroupOrganizationUsersPage />}
        />
        <Route
          path={GROUP_ROUTES.COMPANY_EMISSIONS}
          element={<GroupCompanyEmissionsPage />}
        />
        <Route
          path={GROUP_ROUTES.COMPANY_REPORTS}
          element={<GroupCompanyReportsPage />}
        />
        <Route
          path={GROUP_ROUTES.PURCHASING_EMISSIONS}
          element={<GroupPurchasingEmissionsPage />}
        />
        <Route
          path={GROUP_ROUTES.PURCHASING_FOOD_AND_DRINK}
          element={<GroupFoodAndDrinkPage />}
        />
        <Route
          path={GROUP_ROUTES.PURCHASING_PACKAGING}
          element={<GroupPackagingPage />}
        />
        <Route path={GROUP_ROUTES.PRODUCTS} element={<GroupProductsPage />} />
        <Route
          path={GROUP_ROUTES.PRODUCTS_COLLECTIONS}
          element={<GroupCollectionsPage />}
        />
        <Route element={<SettingsPage />} path={GROUP_ROUTES.SETTINGS} />
      </Route>
    </Route>
  );
}
